import { LucideAirVent } from "lucide-react";
import { Button } from "./components/ui/button";
import { Example, ExampleWrapper } from "./components/ui/example";
import {
	Item,
	ItemActions,
	ItemContent,
	ItemDescription,
	ItemMedia,
	ItemTitle,
} from "./components/ui/item";

export function ComponentPage() {
	return (
		<ExampleWrapper>
			<DefaultVariantItems />
		</ExampleWrapper>
	);
}
function DefaultVariantItems() {
	return (
		<Example title="Default">
			<Item>
				<ItemContent>
					<ItemTitle>Title Only</ItemTitle>
				</ItemContent>
			</Item>
			<Item>
				<ItemContent>
					<ItemTitle>Title + Button</ItemTitle>
				</ItemContent>
				<ItemActions>
					<Button variant="outline">Action</Button>
				</ItemActions>
			</Item>
			<Item>
				<ItemContent>
					<ItemTitle>Title + Description</ItemTitle>
					<ItemDescription>
						This is a description that provides additional context.
					</ItemDescription>
				</ItemContent>
			</Item>
			<Item>
				<ItemContent>
					<ItemTitle>Title + Description + Button</ItemTitle>
					<ItemDescription>
						This item includes a title, description, and action button.
					</ItemDescription>
				</ItemContent>
				<ItemActions>
					<Button variant="outline">Action</Button>
				</ItemActions>
			</Item>
			<Item>
				<ItemMedia variant="icon">
					<LucideAirVent />
				</ItemMedia>
				<ItemContent>
					<ItemTitle>Media + Title</ItemTitle>
				</ItemContent>
			</Item>
			<Item>
				<ItemMedia variant="icon">
					<LucideAirVent />
				</ItemMedia>
				<ItemContent>
					<ItemTitle>Media + Title + Button</ItemTitle>
				</ItemContent>
				<ItemActions>
					<Button size="sm">Action</Button>
				</ItemActions>
			</Item>
			<Item>
				<ItemMedia variant="icon">
					<LucideAirVent />
				</ItemMedia>
				<ItemContent>
					<ItemTitle>Media + Title + Description</ItemTitle>
					<ItemDescription>
						This item includes media, title, and description.
					</ItemDescription>
				</ItemContent>
			</Item>
			<Item>
				<ItemMedia variant="icon">
					<LucideAirVent />
				</ItemMedia>
				<ItemContent>
					<ItemTitle>Media + Title + Description + Button</ItemTitle>
					<ItemDescription>
						Complete item with all components: media, title, description, and
						button.
					</ItemDescription>
				</ItemContent>
				<ItemActions>
					<Button size="sm">Action</Button>
				</ItemActions>
			</Item>
			<Item>
				<ItemContent>
					<ItemTitle>Multiple Actions</ItemTitle>
					<ItemDescription>
						Item with multiple action buttons in the actions area.
					</ItemDescription>
				</ItemContent>
				<ItemActions>
					<Button variant="outline" size="sm">
						Cancel
					</Button>
					<Button size="sm">Confirm</Button>
				</ItemActions>
			</Item>
		</Example>
	);
}
